import moment from 'moment';
import { REGION_CODES } from '../../constants/regions';



const papaparseToCsvString = (data) => {
    return data.map(row => 
        row.map(cell => {
            const strCell = String(cell === null || cell === undefined ? '' : cell);
            if (strCell.includes(',') || strCell.includes('\n') || strCell.includes('"')) {
                return `"${strCell.replace(/"/g, '""')}"`;
            }
            return strCell;
        }).join(',')
    ).join('\n');
}

const getRegionCsvHeaders = (region) => [
    `${region} TOTAL`,
    `${region} STATUS`,
    `${region} CONTAINER`,
    `PENDING ${region}`,
];

export const generateCsvFromVariants = (
    variants,
    locationsBySelectedRegion,
    pendingData,
    pendingDataUS,
    pendingDataUK,
    containers,
    findSKUStatus,
    locationOrder,
    getLocationDisplayName
) => {
    if (!variants || !locationsBySelectedRegion || !pendingData || !pendingDataUS || !pendingDataUK || !containers) {
        const basicHeaders = ['SKU', 'Variant Name', ...REGION_CODES.flatMap(getRegionCsvHeaders)];
        return papaparseToCsvString([basicHeaders]);
    }

    const generateCsvHeaders = () => {
        const originalHeaders = ['SKU', 'Variant Name'];
        const headerMapping = {};

        REGION_CODES.forEach(region => {
            if (!locationsBySelectedRegion[region]?.length) return;

            originalHeaders.push(...getRegionCsvHeaders(region));
            locationsBySelectedRegion[region].forEach(location => {
                originalHeaders.push(location);
                headerMapping[location] = getLocationDisplayName ? getLocationDisplayName(location) : location;
            });
        });

        return { originalHeaders, headerMapping };
    };

    const { originalHeaders, headerMapping } = generateCsvHeaders();

    const tableData = {};
    const usLocations = locationsBySelectedRegion?.['US'] || [];
    const ukLocations = locationsBySelectedRegion?.['UK'] || [];

    variants.forEach(variant => {
        const sku = variant?.sku;
        if (!sku) return;
        
        const containerLineData = [...(containers || [])].reverse().map(container => {
            const containerLine = container?.containerLines?.find(cl => cl?.sku === sku);
            const count = containerLine?.quantity || 0;
            const location = container?.landingLocation?.name;
            const date = container?.arrivalDate;
            const country = usLocations.includes(location) ? 'US' : ukLocations.includes(location) ? 'UK' : 'AU';
            return { count, location, date, country };
        }).filter(val => val.count !== 0);

        const usList = containerLineData.filter(val => val.country === 'US');
        const auList = containerLineData.filter(val => val.country === 'AU');
        const ukList = containerLineData.filter(val => val.country === 'UK');

        tableData[sku] = {
            usNextContainer: usList.length > 0 ? usList[0] : null,
            auNextContainer: auList.length > 0 ? auList[0] : null,
            ukNextContainer: ukList.length > 0 ? ukList[0] : null,
        };
    });

    const rows = variants.map(variant => {
        const sku = variant?.sku;
        if (!sku) return originalHeaders.map(() => '');
        
        const locationCounts = variant?.locationCounts || {};

        const rowData = {};
        originalHeaders.forEach(header => {
            rowData[header] = locationCounts[header] || 0;
        });

        rowData['SKU'] = sku;
        rowData['Variant Name'] = variant?.variantName || '';

        const pendingAU = pendingData?.[sku] || 0;
        const pendingUS = pendingDataUS?.[sku] || 0;
        const pendingUK = pendingDataUK?.[sku] || 0;

        const auLocations = locationsBySelectedRegion?.['AU'] || [];

        const auTotal = auLocations.reduce((sum, loc) => sum + (locationCounts[loc] || 0), 0) - pendingAU;
        const usTotal = usLocations.reduce((sum, loc) => sum + (locationCounts[loc] || 0), 0) - pendingUS;
        const ukTotal = ukLocations.reduce((sum, loc) => sum + (locationCounts[loc] || 0), 0) - pendingUK;

        rowData['AU TOTAL'] = auTotal;
        rowData['US TOTAL'] = usTotal;
        rowData['UK TOTAL'] = ukTotal;

        rowData['PENDING AU'] = pendingAU;
        rowData['PENDING US'] = pendingUS;
        rowData['PENDING UK'] = pendingUK;

        rowData['AU STATUS'] = findSKUStatus?.(sku, 'AU') || 'Unknown';
        rowData['US STATUS'] = findSKUStatus?.(sku, 'US') || 'Unknown';
        rowData['UK STATUS'] = findSKUStatus?.(sku, 'UK') || 'Unknown';

        const skuForTable = sku.split('-').filter((val) => val !== 'P' && val !== 'LE').join('-');
        rowData['AU CONTAINER'] = tableData[skuForTable]?.auNextContainer?.date ? moment(tableData[skuForTable].auNextContainer.date).format('DD-MM-YYYY') : '';
        rowData['US CONTAINER'] = tableData[skuForTable]?.usNextContainer?.date ? moment(tableData[skuForTable].usNextContainer.date).format('DD-MM-YYYY') : '';
        rowData['UK CONTAINER'] = tableData[skuForTable]?.ukNextContainer?.date ? moment(tableData[skuForTable].ukNextContainer.date).format('DD-MM-YYYY') : '';

        return originalHeaders.map(header => {
            const value = rowData[header];
           
            if (header.includes('TOTAL') || header.includes('PENDING') || 
                (!header.includes('STATUS') && !header.includes('CONTAINER') && header !== 'SKU' && header !== 'Variant Name')) {
                return value || 0;
            }
            return value || '';
        });
    }).filter(row => row[0] !== ''); 

    const displayHeaders = originalHeaders.map(header => 
        headerMapping[header] || header
    );

    return papaparseToCsvString([displayHeaders, ...rows]);
};
